import React from "react";

// Mentis chat/avatar emblem — the official Mentogram square lightbulb mark.
export const MentisMark = ({ size = 30, pulse = false, className = "" }) => {
  const s = size;
  return (
    <div
      className={`relative inline-flex items-center justify-center overflow-hidden ${pulse ? "mentis-pulse" : ""} ${className}`}
      style={{ width: s, height: s, borderRadius: "24%" }}
      data-testid="mentis-mark"
    >
      <img
        src={`${process.env.PUBLIC_URL || ""}/mentogram-icon.png`}
        alt="Mentis"
        className="w-full h-full object-cover select-none"
        draggable="false"
      />
    </div>
  );
};

export const MentisWordmark = ({ className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <img
      src={`${process.env.PUBLIC_URL || ""}/mentogram-logo-dark.png`}
      alt="Mentogram"
      className="h-11 sm:h-12 w-auto select-none"
      draggable="false"
      data-testid="brand-logo"
    />
    <div className="hidden sm:block leading-none border-l border-black/15 pl-2.5">
      <div className="mono-label text-[9px] text-orange-600">Admissions</div>
    </div>
  </div>
);

export default MentisMark;
